<template>
  <div v-if="task != null">
    <h6 class="mb-2">Guardado planificado</h6>

    <v-row>
      <v-col cols="12" md="3" v-if="task.lpn">
        <div class="text-caption text-medium-emphasis">LPN a guardar</div>
        <div>{{ task.lpn.code }}</div>
      </v-col>
      <v-col cols="12" md="3" v-if="task.lpn && task.lpn.state">
        <div class="text-caption text-medium-emphasis">Estado del LPN</div>
        <v-chip size="small">{{ task.lpn.state.name }}</v-chip>
      </v-col>
      <v-col cols="12" md="3" v-if="task.lpn && task.lpn.flow_type">
        <div class="text-caption text-medium-emphasis">Flujo</div>
        <v-chip size="small">{{ task.lpn.flow_type.name }}</v-chip>
      </v-col>
      <v-col cols="12" md="3" v-if="task.lpn && task.lpn.nro_bulto">
        <div class="text-caption text-medium-emphasis">Nro. de bulto</div>
        <div>{{ task.lpn.nro_bulto }}</div>
      </v-col>

      <v-col cols="12" md="3">
        <div class="text-caption text-medium-emphasis">Ubicación actual</div>
        <div v-if="task.ubicacion">
          {{ task.ubicacion.code }}
          <span v-if="task.ubicacion.zona" class="text-caption text-grey-600">- {{ task.ubicacion.zona.label }}</span>
        </div>
        <span v-else>Sin ubicar</span>
      </v-col>
    </v-row>

    <v-alert type="info" variant="tonal" density="compact" class="mt-3">
      El destino lo define el operario al ejecutar la tarea.
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "TaskViewDetalleGuardado",
  props: {
    task: Object,
    descriptivos: { type: Array, default: () => [] },
  },
};
</script>
